import {CircularProgress, Container, Grid, Typography} from "@mui/material"
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "i18nano";
import {useApplicantCheck} from "../hooks/useApplicantCheck";
import PartyCard from "../components/PartyCard";
import {useEffect, useMemo} from "react";

const ApplicantsPage = () => {
    const navigate = useNavigate();
    const t = useTranslation();
    const {id} = useParams();

    const numericId = useMemo(() => id ? parseInt(id) : undefined, [id]);

    const {applicant, loading, refresh, getCurrentApplicantId} = useApplicantCheck(numericId);

    useEffect(() => {
        if (numericId) {
            refresh(numericId);
            return;
        }
        const currentApplicantId = getCurrentApplicantId();
        if (currentApplicantId) {
            refresh(currentApplicantId);
        }
    }, []);

    const renderContent = () => {
        if (loading) {
            return <CircularProgress sx={{position: "absolute", left: "calc(50% - 20px)", top: "30%"}}/>
        } else if (!applicant) {
            return <Typography variant={"h5"}>{t("You don't have access to this client")}</Typography>
        } else {
            return (
                    <>
                        <Grid container spacing={3} alignItems="stretch" justifyContent={"center"}>
                            {applicant.parties.map((party) => {
                                return (<Grid
                                                item
                                                key={party.id}
                                                xs={12}
                                                sm={6}
                                                md={3}
                                                display={"flex"}
                                        >
                                            <PartyCard party={party} onClick={() => navigate(`/party/${party.id}`)}/>
                                        </Grid>
                                )
                            })}
                        </Grid>
                    </>
            )
        }
    }

    return (
            <Container sx={{paddingTop: 3}}>
                {renderContent()}
            </Container>
    )
}

export default ApplicantsPage;